import { NgStyle, NgClass } from '@angular/common';
import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { environment } from '../../../../environments/environment.prod';
import { DefaultClassDirective } from '../../../flex-layout/class';
import { CustomFlexLayoutModule } from '../../../flex-layout/custom-flex-layout.module';
import { DefaultLayoutDirective } from '../../../flex-layout/custom-layout';
import { DefaultLayoutAlignDirective } from '../../../flex-layout/custom-layout-align';
import { DefaultLayoutGapDirective } from '../../../flex-layout/custom-layout-gap';
import { DefaultFlexDirective } from '../../../flex-layout/flex';
import { DefaultStyleDirective } from '../../../flex-layout/style';
import { ContentAnimDirective } from '../../product-layout/content-anim.directive';
import { EditorTextComponent } from '../editor-text/editor-text.component';
import { MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { NgOptimizedImageComponent } from '../ng-optimized-image/ng-optimized-image.component';

@Component({
  selector: 'calsoft-faq',
  imports: [DefaultLayoutDirective, NgOptimizedImageComponent,ContentAnimDirective, CustomFlexLayoutModule, DefaultLayoutAlignDirective, EditorTextComponent, DefaultStyleDirective, DefaultFlexDirective, NgStyle, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, DefaultLayoutGapDirective, NgClass, DefaultClassDirective, MatIcon, MatSuffix],
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss'
})
export class FaqComponent {

   clickedPerk: any = null;
  selectedPerkIndex: number = 0;


  autoSlideInterval: any;

  showPerkData(index: number,perk: any): void {
    this.selectedPerkIndex = index;
    this.clickedPerk = { ...perk }; // Create a new reference
    // console.log('The Clicked Perk is', JSON.stringify(this.clickedPerk));
    this.cdr.detectChanges();
    this.startAutoSlide();  // Trigger change detection

  }
  @Input() item: any;

  @Input() faq: any;


  @Input() data: any;

  panelOpenState: boolean = false;
  item_visible: boolean = true;

  customField15: any;
  customField16: any;
  customField17: any;
  customField18: any;

  public serverPath = environment.commonImageApi + '/commonSlider/';
  public serverPath2 = environment.commonImageApi + '/home/';

  index: number = 0;

  constructor(
    private cdr: ChangeDetectorRef,
  ) {

  }

ngOnInit() {
  if (this.item?.images?.length) {
    this.selectedPerkIndex = 0;
    this.clickedPerk = { ...this.item.images[0] };
  }
  this.startAutoSlide(); // Start timer
}

startAutoSlide() {
  this.clearAutoSlide(); // Clear existing interval if any

  this.autoSlideInterval = setInterval(() => {
    this.selectedPerkIndex = (this.selectedPerkIndex + 1) % this.item.images.length;
    this.clickedPerk = { ...this.item.images[this.selectedPerkIndex] };
    this.cdr.detectChanges();
  }, 15000); // 10 seconds
}

clearAutoSlide() {
  if (this.autoSlideInterval) {
    clearInterval(this.autoSlideInterval);
    this.autoSlideInterval = null;
  }
}

onUserClick(index: number) {
  this.clearAutoSlide(); // Stop the current timer
  this.selectedPerkIndex = index;
  this.clickedPerk = { ...this.item.images[index] };
  this.cdr.detectChanges();

  this.startAutoSlide(); // Restart the 30s timer from now
}

  
  openedPanelTitle: string | any;

  expandedIndex: any;
  onPanelOpen(title: string, index: number) {
    if (this.expandedIndex !== -1 && this.expandedIndex !== index) {
      this.expandedIndex = -1;
      this.cdr.detectChanges();
    }
    this.expandedIndex = index;
    this.openedPanelTitle = title;
    this.panelOpenState = true;
    this.cdr.detectChanges();
  }

  onPanelClose(index: number) {
    if (this.expandedIndex === index) {
      this.expandedIndex = -1;
      this.openedPanelTitle = null;
      this.panelOpenState = false;
      this.cdr.detectChanges();
    }
  }

  toggleSection() {
    this.item_visible = !this.item_visible;
  }

}
